import { Hotel } from "typings/microserviceModels/hotels-flex-module";

/**
 * An utility to check if the hotel has a valid price and to check if we should show "Get Rates"
 * @param hotel
 * @param isMobile
 * @param showCheckPrices
 * @param showGetPriceIfNoPrice
 */
export function validPrice(
  hotel: Hotel,
  isMobile?: boolean,
  showCheckPrices?: boolean,
  showGetPriceIfNoPrice?: boolean
) {
  const { formattedPrice, hotelPrice } = hotel;
  const showCheckPricesDesktop = !isMobile && showCheckPrices;
  const isValidPrice = !showCheckPricesDesktop && formattedPrice && hotelPrice && hotelPrice.value !== "0";
  const showGetRates = !isValidPrice && !showCheckPrices && showGetPriceIfNoPrice;

  return {
    isValidPrice,
    showGetRates,
  };
}
